import * as types from "../constants";
import moment from 'moment';
const initialState = {
  filter: {
    year: {value: moment().format('YYYY'), label: moment().format('YYYY')},
    size: [{}],
    chart: {value: 'production', label: 'Units Produced'}
  },
  list: [],
  chart:{
    graph: [],
  },
  pots: {
    list: [],
    selected: {}
  },
  controlParam: {
    avgWage: '10.00'
  }
}

export default function reducer(state = initialState, actions){
  const { type, payload } = actions;

  switch(type){
    case types.GET_PRODUCTIONS:
      console.log(state.filter)
      return {
        ...state,
        sizes: payload.sizes,
        years: payload.years
      }
    case types.SORT_CHART:
      return {
        ...state,
        list: payload.list,
        chart: {
          graph: payload.graph,
          dates: payload.dates
        }
      }
    case types.UPDATE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          [payload.name]: payload.e
        }
      }
    case types.GET_POTS:
      return {
        ...state,
        pots: {
          list: payload,
          selected: {}
        }
      }
    case types.SET_WAGE:
      return {
        ...state,
        controlParam: {
          ...state.controlParam,
          avgWage: payload
        }
      }
    default:
      return {
        ...state
      }
  }
}
